import React from 'react'
import { Grid } from './styles'

export const GridLayout: React.FC = ({ children }) => {
  return <Grid>{children}</Grid>
}
